import {
  SET_SELECTED_FOLDER,
  REFRESH_FOLDER,
  SET_ROOT_FOLDER,
  SET_DATA_SOURCE,
} from "../actions/documentAction";

const defaultState = {
  selectedFolder: null,
  refreshFolder: false,
  rootFolder: null,
  dataSource: {
    data: [],
    listId: undefined
  }
};

export const documentReducer = (state = defaultState, action: any) => {
  const { type, data } = action;
  switch (type) {
    case SET_SELECTED_FOLDER:
      return { ...state, selectedFolder: data };
    case REFRESH_FOLDER:
      return { ...state, refreshFolder: data };
    case SET_ROOT_FOLDER:
      return { ...state, rootFolder: data };
    case SET_DATA_SOURCE:
      return { ...state, dataSource: data}
    default:
      return { ...state };
  }
};
